import { AppConfig } from "../data/loadConfiguration"
import { LoginMatch } from "../login/matchLoginUrl"
import { getLanguageId } from "./getLanguageId"
import { loadLocalizationConfig, loadLanguagesConfig, shouldStoreLocales } from "./utils"

export async function initializeLocalization(appConfig: AppConfig, loginMatch?: LoginMatch | undefined) {
    const languageId = getLanguageId(appConfig, loginMatch) // load correct language id, prio -> sso languageid, stored language id, config language id

    const [localizationConfig = { language: "en", id: "4", translation: {} }, languagesConfig = {}] = await Promise.all([
        loadLocalizationConfig(languageId), // load language
        loadLanguagesConfig(),
    ])

    shouldStoreLocales(localizationConfig, appConfig) // now store correct id and language in the localStorage

    return { localizationConfig, languagesConfig }
}
